module.exports = "<p>\r\n  admin works!\r\n</p>\r\n"